<template>
  <div class="footer"> 
      <div class='storge' >storage</div>
      <div class='storge1' >16 gb /200 gb</div>
  </div>
</template>



<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footer{
    background-color: #FFF;
    max-height: 81px;
    border: 0px;
    border-style: solid;
    padding: 24px 85px 24px 85px;
    display: flex;
    flex-direction: row;
    width:100%;
  }

 .storge{
  text-transform: uppercase;
  text-align: center;
  align-self: center;
  font-size: 24px;
  font-style: "Helvetica Neue" bold;
  line-height: 24px;
}

 .storge1{
  margin-left: 22px;
  text-transform: uppercase;
  text-align: center;
  align-self: center;
  font-size: 16px;
  font-style: "Helvetica Neue" bold;
  line-height: 16px;
}
</style>
